export default __webpack_public_path__ + "static/media/feature-template-empty-state.669f48a3.png";